/* eslint-disable react/prop-types */

import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import axiosInstance from "src/common/axiosInstance";
import SignatureCanvas from 'react-signature-canvas';
import { updateProposal } from "src/slices/Proposals/reducer";
import { useDispatch } from "react-redux";
interface SignNowModalProps {
    isOpen: boolean;
    toggle: () => void;
    proposal_id: number;
    session_user_name: string;
    q1_user_name: string;
    q1_user_sign: string;
    q1media_users_id: number;
    amount: number;
    account_name : string;
    setHideSignNow: (val: boolean) => void;
    setHideSubmitSuggestion : (val: boolean) => void;
}

const SignNow: React.FC<SignNowModalProps> = ({
    isOpen,
    toggle,
    proposal_id,
    session_user_name,
    q1_user_name,
    q1_user_sign,
    q1media_users_id,
    amount,
    account_name,
    setHideSignNow,
    setHideSubmitSuggestion
}) => {
    const dispatch = useDispatch();
    const colors = ["#206fc1", "#000FFF", "#ef0404", "#000000"];
    const sigPad = useRef<typeof SignatureCanvas.prototype>(null);
    const [selectedColor, setSelectedColor] = useState(colors[0]);
    const [mode, setMode] = useState("type"); // or "type"
    const [typedName, setTypedName] = useState(session_user_name);
    const [agree, setAgree] = useState(false);
    const [signatureImage, setSignatureImage] = useState<string | null>(null);
    const [q1signatureImage, setQ1SignatureImage] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const clear = () => {
        sigPad.current?.clear();
    };
    const [modalSignSuccess, setModalSignSuccess] = useState(false);

    function togSignSuccess() {
        setModalSignSuccess(!modalSignSuccess);
        removeBodyCss();
        if(modalSignSuccess){
            setLoading(false);
        }
    }
    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    const getTypedSignatureImage = (name: string, color: string): string => {
        const canvas = document.createElement('canvas');
        canvas.width = 390;
        canvas.height = 98;
        const ctx = canvas.getContext('2d');

        if (!ctx) return "";

        ctx.font = 'italic normal 2.9em/50px "Georgia", "Times", serif';
        ctx.fillStyle = color;
        ctx.fillText(name, 10, 60); // Y-position adjusted for better alignment

        return canvas.toDataURL("image/png");
    };

    const setSignature = async () => {
        let signatureImage = "";
        let q1signatureImage = "";
        q1signatureImage = getTypedSignatureImage(q1_user_name, selectedColor);
        if (mode === "type") {
            signatureImage = getTypedSignatureImage(typedName, selectedColor);

        } else if (mode === "draw" && sigPad.current && !sigPad.current.isEmpty()) {
            signatureImage = sigPad.current.toDataURL("image/png");
        }
        if (signatureImage == '' || signatureImage == undefined) {
            toast.error("Please draw Sign!");
            return;
        }

        if (q1signatureImage) {
            setQ1SignatureImage(q1signatureImage);
        }
        if (signatureImage) {
            setSignatureImage(signatureImage);
        } else {
            toast.error("Please draw Sign.");
        }
        const data = {
            img: signatureImage,
            q1_sign: q1signatureImage,
            id: proposal_id,
            sign: q1_user_sign,
            q1media_user: q1_user_name,
            q1media_users_id: q1media_users_id
        }
        setLoading(true);
        const response = await axiosInstance.post("/sign-proposal", data);
        if (response.data.status) {
            const proposalUpdate = {
                id : response.data.data.id,
                status : response.data.data.proposal_status,
                order_name : response.data.data.order_name,
                user_name: response.data.data.user_name,
                start_date: response.data.data.start_date,
                end_date: response.data.data.end_date,
                amount: amount,
                account_name : account_name
            }
            dispatch(updateProposal(proposalUpdate)); 
            setHideSignNow(true);
            setHideSubmitSuggestion(true);
            togSignSuccess();
        } else {
            setLoading(false);
            toast.error(response.data.msg);
        }
        toggle(); // Close modal
    }
    return (
        <>
            <Modal isOpen={isOpen} toggle={toggle} size="md">
                <ModalHeader toggle={toggle}>Sign Proposal</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="name">Print Name</Label>
                            <Input
                                id="name"
                                value={typedName}
                                onChange={(e) => setTypedName(e.target.value)}
                                maxLength={30}
                            />
                        </FormGroup>

                        <FormGroup>
                            <div className="d-flex justify-content-center mb-2">
                                {colors.map((color) => (
                                    <div
                                        key={color}
                                        onClick={() => {
                                            setSelectedColor(color);
                                            sigPad.current?.clear(); // clear the canvas on color change
                                        }}
                                        style={{
                                            backgroundColor: color,
                                            width: 25,
                                            height: 25,
                                            margin: "0 6px",
                                            borderRadius: "50%",
                                            border: selectedColor === color ? "2px solid green" : "1px solid #ccc",
                                            cursor: "pointer"
                                        }}
                                    />
                                ))}
                            </div>
                        </FormGroup>

                        <Row className="mb-3 text-center">
                            <Col>
                                <Button color={mode === "type" ? "primary" : "secondary"} onClick={() => setMode("type")}>
                                    Type It
                                </Button>{" "}
                                <Button color={mode === "draw" ? "primary" : "secondary"} onClick={() => setMode("draw")}>
                                    Draw It
                                </Button>{" "}
                                <Button color="warning"
                                    onClick={clear}
                                >
                                    Clear
                                </Button>
                            </Col>
                        </Row>

                        <FormGroup>
                            {mode === "draw" ? (
                                <SignatureCanvas
                                    ref={sigPad}
                                    penColor={selectedColor}
                                    canvasProps={{
                                        width: 500,
                                        height: 150,
                                        className: "sigCanvas border rounded w-100"
                                    }}
                                />
                            ) : (
                                <div className="border rounded p-3 text-center" style={{
                                    margin: 0,
                                    padding: "0 5px",
                                    zIndex: 90,
                                    cursor: "default",
                                    color: selectedColor,
                                    font: 'italic normal 2.0em / 50px "Georgia", "Times", serif',
                                }}>
                                    {typedName || "Your Signature"}
                                </div>
                            )}
                        </FormGroup>

                        <FormGroup check>
                            <Input
                                id="agree"
                                type="checkbox"
                                checked={agree}
                                style={{ fontSize: "x-large", marginLeft: "-16px", marginTop: "0px" }}
                                onChange={() => setAgree(!agree)}
                            />
                            <Label for="agree" check style={{ marginLeft: "10px" }}>
                                I Agree to Sign
                            </Label>
                            <div className="mt-2" style={{ fontSize: "0.75rem" }}>
                                <ul className="mb-0">
                                    <li>
                                        Advertiser agrees to adhere to IAB terms and conditions:&nbsp;
                                        <a
                                            href="https://www.iab.com/wp-content/uploads/2015/06/IAB_4As-tsandcs-FINAL.pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            IAB terms and conditions
                                        </a>{" "}
                                        with choice of law, jurisdiction, and venue per section XIV(d) exclusively in Texas/Austin, Texas.
                                    </li>
                                    <li>Payment – due within 30 days upon invoicing.</li>
                                    <li>Out clause – 72 hours.</li>
                                </ul>
                            </div>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        disabled={!agree}
                        onClick={() => {
                            setSignature();
                        }}
                    >
                        {loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    "Agree & Sign"
                                )}
                        
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal size="lg" isOpen={modalSignSuccess} toggle={togSignSuccess}>
                <div className="modal-body">
                    <h5 className="modal-title mt-0 text-center" id="myLargeModalLabel">
                        Thank You!
                    </h5>
                    <br />
                    <p>We have received your campaign details and your campaign has been submitted.</p>
                    <p>Your AE and AO Contacts will be in touch soon. Typically no later than 1-2 weeks prior to your scheduled campaign start date.</p>
                    <p>You will receive an email confirmation with the signed copy of your campaign.</p>
                    <p><b>As a next step, please complete the following questions for our Account Ops Team so we can best serve your campaign. If you do not know how you&apos;d like to answer at this time, you can always come back and fill these out later.</b></p>
                    <ol>
                        <ol>
                            <li><b>How often do you need a report.</b></li>
                            <li><b>Is there a certain day of the week you would like to receive reports.</b></li>
                            <li><b>What specific details would you like to see in the campaign Wrap-Up Report.</b></li>
                            <li><b>Special Invoice Instructions.</b></li>
                        </ol>
                    </ol>
                    {/* Save Button */}
                    <Row className="mb-3">
                        <Col md={12} style={{ textAlign: "right" }}>
                            <Button
                                color="primary"
                                type="button" // Ensure button type is "button" to avoid form submission on click
                                className="w-md"
                                onClick={togSignSuccess} // Call the handler when saving
                            >
                                OK
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal>
        </>

    );
}

export default SignNow;